import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'Karina G.',
  quote: 'Volvió a mirarme distinto.',
  note: 'Sentí que dejé de ser invisible.'
}, {
  name: 'María Emilia S.',
  quote: 'Volví a sentirme mujer.',
  note: 'Me había perdido a mí misma.'
}, {
  name: 'Camila G.',
  quote: 'Dejé de rogar atención.',
  note: 'Y él volvió a buscarme.'
}, {
  name: 'Ana María S.',
  quote: 'Recuperamos la conexión.',
  note: 'Como si volviéramos al principio.'
}, {
  name: 'Lola G.',
  quote: 'No pensé que algo tan simple pudiera cambiar tanto.',
  note: 'Volvimos a sentirnos pareja.'
}];
export function Testimonials() {
  return <section className="py-10 md:py-16 px-6" data-id="element-212">
      <div className="max-w-3xl mx-auto" data-id="element-213">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-214">
          <p className="text-[11px] md:text-xs tracking-[0.25em] uppercase text-burgundy/60 font-medium mb-3" data-id="element-215">
            Lo que dicen
          </p>
          <h2 className="font-playfair text-[26px] md:text-4xl text-burgundy leading-tight font-light mb-3" data-id="element-216">
            Ellas ya lo vivieron
          </h2>
          <div className="w-10 h-px bg-gold/60 mx-auto" data-id="element-217" />
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-4 md:gap-5" data-id="element-218">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="bg-white/55 backdrop-blur-sm p-5 md:p-6 rounded-xl border border-burgundy/8" data-id="element-219">
              <div className="flex gap-1 mb-2.5" data-id="element-220">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-gold text-gold" data-id="element-221" />)}
              </div>
              <p className="font-playfair text-[17px] md:text-lg text-burgundy leading-snug italic mb-2" data-id="element-222">
                "{t.quote}"
              </p>
              <p className="text-[13px] md:text-sm text-charcoal/65 leading-snug mb-3" data-id="element-223">
                {t.note}
              </p>
              <p className="text-[12px] tracking-[0.1em] uppercase font-medium text-charcoal/50" data-id="element-224">
                — {t.name}
              </p>
            </motion.div>)}
        </div>

        <p className="text-center mt-6 text-[13px] md:text-sm italic text-charcoal/55" data-id="element-225">
          Cientos de mujeres ya empezaron a recuperar su conexión.
        </p>
      </div>
    </section>;
}